import {DiplomatObject} from 'types/DiplomatObject';
import * as yup from 'common/yup';

export const WebServerSettingsNames = {
   webClientEnabled: 'webClientEnabled',
   enforceWebClientPGP: 'enforceWebClientPGP',
   webClientPgpKeyId: 'webClientPgpKeyId',
   webClientSessionTimeout: 'webClientSessionTimeout',
} as const;

export const WebServerSettings = DiplomatObject.shape({
   [WebServerSettingsNames.webClientEnabled]: yup.boolean(),
   [WebServerSettingsNames.enforceWebClientPGP]: yup.boolean(),
   [WebServerSettingsNames.webClientPgpKeyId]: yup.string(),
   [WebServerSettingsNames.webClientSessionTimeout]: yup.number().min(0).default(15),
});
export type IWebServerSettings = yup.InferType<typeof WebServerSettings>;
